import React from 'react';
import { convertAmount, getAmountWithCurrency, useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { TranslationKeys } from '../../../enums';
import ImgWinStar from '../../../assets/images/win-popup-star.png';
import { doBetStore } from '../../../store';

export const WinPopup = observer(() => {
  const t = useTranslation();
  const { winAmount } = doBetStore;

  return winAmount ? (
    <div className='dream-wheel-popup-win'>
      <div className='dream-wheel-popup-win-holder'>
        <p className='wheel-popup-win-text'>{t(TranslationKeys.YouWin)}</p>
        <p className='wheel-popup-win-amount'>
          {getAmountWithCurrency({ amount: convertAmount(winAmount) })}
        </p>
        <img src={ImgWinStar} className='win-pop-img1' alt='star' />
        <img src={ImgWinStar} className='win-pop-img2' alt='star' />
        <img src={ImgWinStar} className='win-pop-img3' alt='star' />
        <img src={ImgWinStar} className='win-pop-img4' alt='star' />
        <img src={ImgWinStar} className='win-pop-img5' alt='star' />
      </div>
    </div>
  ) : (
    <></>
  );
});
